<template>
  <div>
    <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin  -->
    <v-card class="box" ref="selectedCard">
      <!-- outward data --{{ outward_list.sender }} <br /><br /> -->
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Mark Outward </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <!-- <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>OutWard Date</b></p>
          <v-menu
          ref="menu11"
            v-model="menu11"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_1"
                label="Outward Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                persistent-hint
                hint="YYYY-MM-DD FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_1"
              @input="menu11 = false"
              ref="rv"
            ></v-date-picker>
          </v-menu>
        </v-col> -->

        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Sender</b></p>
          <v-autocomplete color="#0F2027" dense rounded required return-object v-model="sender" :items="sender_list"
            item-text="name" label="Sender" outlined persistent-hint hint="Please Select Sender" />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Receiver</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="receiver" :items="receiver_list"
            @change="getaddress" item-text="name" label="Receiver" return-object outlined persistent-hint
            hint="Please Select Receiver" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Description</b></p>
          <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Receiver's Address</b></p>
          <v-textarea outlined name="input-7-4" v-model="address" label="Receiver's Address"></v-textarea>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="4">
          <v-text-field label="Date" rounded outlined dense type="date" v-model="outward_date"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col col="12" sm="2" md="2">
          <v-btn class="button" :disabled="isSaveButtonDisabled" @click="addOutwardData()">{{ save_edit }}</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- table view -->

    <v-card class="box">
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <v-btn color="success" outlined rounded v-if="outward_list.length != 0">
            <download-excel class="mr-2 pb-3 pt-2" :data="outward_list" :fields="table_fields" worksheet="OutwardReport"
              name="OutwardReport.xls">
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>
        </v-col>
        <v-col sm="4" md="4" cols="12">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <v-data-table :headers="headers" :items="outward_list" :search="search" class="dataTable">
        <!-- <v-data-table :headers="headers"> -->

        <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Outward Report</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <!-- <center>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-col>
        </center> -->

        <template v-slot:[`item.edit`]="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <div>
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deletePlanData(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    outward_date:new Date().toISOString().slice(0, 10),
    snackbar_msg: "",
    color: "",
    extraBreadcrumbItems: [
    

    ],
    breadcrumbClass: "breadcrumb-style1",

    snackbar: false,
    overlay: false,
    //   menu11: false,
    //   date_1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    //dateFormatted:vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),

    description: "",
    address: "",
    sender: "",
    receiver: "",
    sender_list: [],
    receiver_list: [],
    search: "",
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Outward No", value: "outward_no" },
      { text: "Outward Date", value: "iodate" },

      { text: "Sender", value: "sender.name" },
      { text: "Receiver", value: "outwardreceiver.name" },
      { text: "Description", value: "description" },
      { text: "Address", value: "address" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
    table_fields: {
      "Sr. No": "srno",
      "Outward No": "outward_no",
      "Outward Date": "iodate",
      Sender: "sender.name",
      Receiver: "outwardreceiver.name",
      Description: "description",
      Address: "address",
    },
    outward_list: [],
    save_edit: "Save",
    edit_io_id: null,

    ///////////////////////////////////////////////
  }),
  mounted() {
    //this.dateFormatted=this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    this.onload();
  },
  computed: {
    isSaveButtonDisabled() {
      return !(this.description && this.sender && this.receiver);
    },
  },

  methods: {
    onload() {
      this.save_edit = "Save";
      axios
        .post("/inwardOutward/outward")
        .then((res) => {
          if (res.data.flag == "YES") {
            console.log("outward_list", res.data.outward_list);
            this.sender_list = res.data.sender;
            this.receiver_list = res.data.receiver;
            this.outward_list = res.data.outward_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getaddress() {
      this.address = this.receiver.address;
    },
    addOutwardData() {
      console.log("in save btn click");
      const formdata = {
        edit_io_id: this.edit_io_id,
        senderid: this.sender.id,
        receiverid: this.receiver.id,
        description: this.description,
        address: this.address,
        save_edit: this.save_edit,
        outward_date: this.outward_date,
      };
      axios
        .post("/inwardOutward/saveoutward", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            console.log("in save btn axios");

            //this.outward_list = res.data.outward_list
            console.log("io", res.data.io);
            this.showSnackbar("green", res.data.snackbar);
            //this.outward_list.splice(0, 0, res.data.io);
            this.reset();
            this.onload();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
      //   this.overlay = true;
    },
    reset() {
      this.save_edit = "Save";
      this.edit_io_id = null;
      this.sender = "";
      this.receiver = "";
      this.description = "";
      this.address = "";
    },
    editItem(item) {
      this.$vuetify.goTo(0); // for scrolling up
      // this.$vuetify.goTo(this.$refs.selectedCard); // for scrolling up

      this.save_edit = "Edit";
      this.edit_io_id = item.id;
      this.sender = item.sender;
      this.receiver = item.outwardreceiver;
      this.description = item.description;
      this.address = item.address;
      this.outward_date = item.iodateEdit
    },
    deletePlanData(item) {
      const formdata = {
        delete_io_id: item.id,
        name: "Outward",
      };
      axios
        .post("/inwardOutward/deleteinwardoutward", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.onload();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
};
</script>

<style scoped>
.v-data-table ::v-deep th {
  font-size: 14px !important;
  font-weight: 800 !important;
}
</style>